import React, { useState, useEffect } from "react";
import "./App.css";
// import Logo from "./components/Logo";
// import AuthLinks from "./components/AuthLinks";
// import { useNavigate, Link } from "react-router-dom";
import { Link } from "react-router-dom";
import logoRed from "./branding/thefeedgram.svg";
import introImage from "./screenshots/intro_image.webp";
import tagView from "./screenshots/tag_view.webp";
import analyseImage from "./screenshots/analyse_sentiment.webp";
import sentimentImage from "./screenshots/sentiment.webp";
import noteImage from "./screenshots/note.webp";
import summaryImage from "./screenshots/summary.webp";
import localForage from "localforage";
import VerifyTokenMutation from "./mutations/VerifyTokenMutation";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import * as serviceWorkerReg from "./serviceWorkerRegistration";
import Banner from "react-js-banner";

function App() {
    // const navigate = useNavigate();
    const [showReload, setShowReload] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState(null);
    const [showBanner, setShowBanner] = useState(true);
    const onSWUpdate = (registration) => {
        setShowReload(true);
        setWaitingWorker(registration.waiting);
    };

    useEffect(() => {
        serviceWorkerReg.register({ onUpdate: onSWUpdate });
    }, []);

    const reloadPage = () => {
        waitingWorker.postMessage({ type: "SKIP_WAITING" });
        setShowReload(false);
        window.location.reload();
    };

    localForage
        .getItem("auth_token_forage")
        .then(function (value) {
            if (value != null) {
                VerifyTokenMutation(value, (verified) => {
                    if (verified) {
                        // navigate("/home");
                    }
                });
            }
        })
        .catch(function (err) {
            console.log("");
        });

    function onDismissClick(e) {
        e.preventDefault();
        setShowBanner(false);
    }

    return (
        <div className="app-container">
            <div data-testid="cookie-element" className="app-header">
                <Banner
                    showBanner={showBanner}
                    css={{
                        height: "0.6rem",
                        backgroundColor: "lightgoldenrodyellow",
                        position: "fixed",
                        left: "0",
                        bottom: "0",
                        width: "100%",
                        fontSize: "12px",
                        margin: 0,
                    }}
                >
                    <div>
                        <p style={{ padding: "4px" }}>
                            We use cookies to enhance The Feedgram experience.
                            By using our website, you agree to our use of
                            cookies.{" "}
                            <a
                                style={{
                                    textDecoration: "underline",
                                    color: "blue",
                                }}
                                onClick={onDismissClick}
                            >
                                Dismiss
                            </a>
                        </p>
                    </div>
                </Banner>
                <div className={`app-header-room`}>
                    <div className="component-box">
                        <div>
                            <img
                                alt="thefeedgram-logo"
                                className="brand-logo"
                                src={logoRed}
                            />
                        </div>
                        <div className={`auth-btn-group`}>
			
							<Link
								className="auth-action-button auth-signup"
								to="/signup"
							>
								Sign up
							</Link>
                            <a
                                className="blog-link"
                                href="https://docs.thefeedgram.com/blog/"
                                target="_blank"
                            >
                                {" "}
                                Blog{" "}
                            </a>
                            <Link className="login-link" to="/login">
                                {" "}
                                Login{" "}
                            </Link>
                        </div>
                    </div>
                </div>
                <Snackbar
                    open={showReload}
                    message="A new version is available!"
                    onClick={reloadPage}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            onClick={reloadPage}
                        >
                            Reload
                        </Button>
                    }
                />
            </div>

            <div className="landing-page-content">
                <div className={`section-0`}>
                    <div className="copy-container">
                        <h1 className={`headline`}>
                            An intelligent reader that just makes sense.
                        </h1>
                        <p className="subline">
                            {/* Stay up to date with relevant information. All from your trusted
              sources. Get unbiased content suggestions that's never based on your reading history. */}
                            Now get unbiased content from your favorite sources
                            that are never based on your reading history.
                        </p>
                        <Link to="/signup">
                            <button className={`btn-welcome`}>
                                Get started for free
                            </button>
                        </Link>
                    </div>
                    <div className={`image-container`}>
                        <img
                            alt="thefeedgram"
                            className="app-screenshot"
                            src={introImage}
                        />
                    </div>
                </div>

                <div className="section-1">
                    <div className={`copy-container`}>
                        <h1 className={`headline`}>
                            Never miss an important topic anymore.
                        </h1>
                        <p className="subline">
                            {/* Using <mark>Advanced Natural Language Processing Algorithms</mark>
              , Feedgram will find the most important topics just for you. Now,
              be the first to know what is relevant for any specific feed. */}
                            Using{" "}
                            <mark>
                                Advanced Natural Language Processing Algorithms
                            </mark>
                            , The Feedgram will find the most important topics
                            from your personalized feeds instead of any unwanted
                            suggestions.
                        </p>
                    </div>
                    <div className={`image-container`}>
                        <img src={tagView} alt="thefeedgram" />
                    </div>
                </div>

                <div className="section-2">
                    <div className={`image-container`}>
                        <img src={analyseImage} alt="thefeedgram" />
                    </div>
                    <div className={`copy-container`}>
                        <h1 className={`headline`}>
                            Know your sources. The best way to find what's right
                            for you.
                        </h1>
                        <p className="subline">
                            {" "}
                            Get valuable insights from your specific sources
                            with{" "}
                            <mark>
                                The Feedgram Advanced Topic Analytics
                            </mark>{" "}
                            to better understand the content you consume.
                        </p>
                        {/* <Link to="/signup"> */}
                        {/*     <button className={`btn-get-started btn-welcome`}> */}
                        {/*         {" "} */}
                        {/*         Get started */}
                        {/*     </button> */}
                        {/* </Link> */}
                    </div>
                </div>

                <div className="section-3">
                    <div className="copy-container">
                        <h1 className={`headline`}>
                            Summarize in a single click.
                        </h1>
                        <p className="subline">
                            {" "}
                            Feedgram's{" "}
                            <mark>
                                Advanced Machine Learning Algorithms
                            </mark>{" "}
                            will summarize long articles for you. Everything in
                            a single click.
                        </p>
                    </div>

                    <div className={`image-container`}>
                        <img src={summaryImage} alt="thefeedgram" />
                    </div>
                </div>

                <div className="section-4">
                    <div className={`image-container`}>
                        <img src={noteImage} alt="thefeedgram" />
                    </div>
                    <div className={`copy-container`}>
                        <h1 className={`headline`}>
                            Make things memorable with Rich-text Notes.
                        </h1>
                        <p className="subline">
                            {" "}
                            Note down everything that matters to you. Cleanly
                            organize your thoughts with meaningful{" "}
                            <mark>Rich-text formatting.</mark>
                        </p>

                        {/* <Link to="/signup"> */}
                        {/*     <button className={`btn-get-started btn-welcome`}> */}
                        {/*         {" "} */}
                        {/*         Get started */}
                        {/*     </button> */}
                        {/* </Link> */}
                    </div>
                </div>

                <div className="section-5">
                    <div className={`image-container`}>
                        <div className={`theme-screenshots`}>
                            {/* <img src={themeLight} alt="thefeedram-light" /> */}
                            {/* <img src={themeDark} alt="thefeedgram-dark" /> */}
                            {/* <img src={themeSepia} alt="thefeedgram-sepia" /> */}

                            <img
                                src={sentimentImage}
                                alt="the feedgram news sentimental analysis"
                            />
                        </div>
                    </div>
                    <div className="copy-container">
                        <h1 className={`headline`}>
                            Quickly find Positive or Negative news and make
                            better decisions.
                        </h1>
                        <p className="subline">
                            Powered by unique <mark>Sentimental Analysis</mark>
                            .&nbsp; Find Positive, Negative news faster and make
                            insightful decisions.
                        </p>

                        <p className="subline">
                            {/* <img width={200} alt="The Feedgram as PWA" src={ pwaIcon }/> */}
                        </p>
                    </div>
                </div>

                <div className="section-6">
                    <div className="copy-container">
                        <h1 className={`headline`}>
                            We respect your right to privacy.
                        </h1>
                        <p className="subline">
                            {" "}
                            We don't share any user data with anyone, for
                            whatever reason. And we believe in building up a
                            healthy internet for everyone.
                        </p>
                    </div>
                </div>

                <div className="footer">
                    <div className="footer-content">
                        <p className="">
                            &copy; opencover technologies pvt ltd. All rights
                            reserved.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default App;
